/* eslint-disable-next-line */
export interface SpeakingBlockProps {}

export function SpeakingBlock(props: SpeakingBlockProps) {
  return (
    <div>
      <h1>Welcome to SpeakingBlock!</h1>
    </div>
  );
}

export default SpeakingBlock;
